import { BehaviorSubject, Subscription, filter, tap } from 'rxjs';
import '../../styles/web-components/product-secondary.scss';
import { showModal } from '../services/dialog.service';
import './product-option-dropdown.ts';
import { allOptionsSelected, getRecommendationParameters, matchesCurrentAndSelectedOptions, NO_SELECTED_VARIANT, shownVariant, UNAVAILABLE_VARIANT } from './product-shared';
import { showInlineCart } from '../helpers/utils';
import { addToCart } from '../services/cart.service';
class ProductSecondary extends HTMLElement {
    constructor() {
        super();
        this.selectedVariant$ = new BehaviorSubject(undefined);
        this.subscriptions = new Subscription();
        this.addEventListener("dropdown:valueChanged", (e) => {
            this.selectedOptions$.next({ ...this.selectedOptions$.value || {}, ...e.detail });
        });
    }
    connectedCallback() {
        this.productId = this.getAttribute('product-id');
        // @ts-expect-error dynamic variable
        this.selectedOptions$ = new BehaviorSubject(window[`initialDefaultSelections${this.productId}`]);
        const formEl = this.querySelector("form");
        formEl.addEventListener("submit", (e) => {
            const target = e.target;
            e.preventDefault();
            if (target.checkValidity()) {
                addToCart({ items: [{ id: this.selectedVariant$.getValue().variantID, quantity: 1 }] }).then((data) => this.handleAddToCart(data))
                    .catch((err) => { console.error(err); });
            }
        });
        const selectedOptionsSub$ = this.selectedOptions$.pipe(tap(selectedOptions => console.log(`selected options for ${this.productId}`, selectedOptions)), filter(selectedOptions => !!selectedOptions), tap((selectedOptions) => this.updateProductOptionsDisplay(selectedOptions)), tap((selectedOptions) => {
            if (allOptionsSelected(selectedOptions)) {
                const selectedVariant = this.getProductVariantsFromOptions(selectedOptions)[0] || UNAVAILABLE_VARIANT;
                this.selectedVariant$.next(selectedVariant);
            }
            else {
                this.selectedVariant$.next(NO_SELECTED_VARIANT);
            }
        })).subscribe();
        const selectedVariantSub$ = this.selectedVariant$.pipe(tap(variant => console.log(`selected variant for ${this.productId}`, variant)), tap(variant => {
            const addToCart = this.querySelector('.product__cta');
            if (variant === null || variant === void 0 ? void 0 : variant.available) {
                addToCart.removeAttribute("disabled");
                addToCart.textContent = window.productUi.ctas.addCart;
            }
            else {
                addToCart.setAttribute("disabled", "true");
                if (variant && !variant.available) {
                    addToCart.textContent = window.productUi.ctas.outOfStock;
                }
                else if (variant === UNAVAILABLE_VARIANT) {
                    addToCart.textContent = window.productUi.ctas.unavailable;
                }
                else {
                    addToCart.textContent = window.productUi.ctas.addCart;
                }
            }
        })).subscribe();
        this.subscriptions.add(selectedOptionsSub$);
        this.subscriptions.add(selectedVariantSub$);
    }
    disconnectedCallback() {
        this.subscriptions.unsubscribe();
    }
    getProductVariantsFromOptions(selectedOptions) {
        return this.getVariants().filter(v => {
            return Object.entries(selectedOptions).filter(entry => !!entry[1]).reduce((acc, curr) => {
                const [key, val] = curr;
                return acc && v.optionsMap[key] === val;
            }, true);
        });
    }
    updateProductOptionsDisplay(selectedOptions) {
        this.querySelectorAll('.product-option-dropdown__item-input').forEach((el) => {
            const labelEl = el.nextElementSibling;
            labelEl.classList.remove('product-option-dropdown__item-label--out-of-stock', 'product-option-dropdown__item-label--unavailable'); // reset style classes
            const optionName = el.id.split("-")[1];
            const optionValue = el.value;
            const isSelectedOption = selectedOptions[optionName] === optionValue;
            let selectBtnTextEl = null;
            if (isSelectedOption) {
                selectBtnTextEl = el.closest('product-option-dropdown').querySelector(".product-option-dropdown__selected-value");
                selectBtnTextEl.classList.remove("product-option-dropdown__selected-value--out-of-stock", "product-option-dropdown__selected-value--unavailable");
                selectBtnTextEl.textContent = labelEl.querySelector(".product-option-dropdown__label-value").textContent;
            }
            const associatedVariants = this.getAssociatedVariants(optionName, optionValue, selectedOptions);
            if (associatedVariants.length) {
                if (!associatedVariants.find(av => av.available)) {
                    labelEl.classList.add("product-option-dropdown__item-label--out-of-stock");
                    if (selectBtnTextEl) {
                        selectBtnTextEl.classList.add("product-option-dropdown__selected-value--out-of-stock");
                    }
                }
            }
            else {
                labelEl.classList.add("product-option-dropdown__item-label--unavailable");
                if (selectBtnTextEl) {
                    selectBtnTextEl.classList.add("product-option-dropdown__selected-value--unavailable");
                }
            }
        });
    }
    getAssociatedVariants(optionName, optionValue, selectedOptions) {
        const associatedVariants = this.getVariants().filter(v => matchesCurrentAndSelectedOptions(v, optionName, optionValue, selectedOptions));
        return associatedVariants;
    }
    getVariants() {
        // @ts-expect-error dynamic variable causes ts issue
        return window[`variantsArray${this.productId}`].filter(shownVariant);
    }
    handleAddToCart(response) {
        var _a;
        if (window.UNTUCKitConfig.showAddToCartOverlay) {
            if ((_a = response === null || response === void 0 ? void 0 : response.items) === null || _a === void 0 ? void 0 : _a.length) {
                const addToCartOverlay = document.createElement('add-to-cart-overlay');
                addToCartOverlay.setAttribute('cart-line-item-data', JSON.stringify(response.items[0]));
                const selectedVariant = this.selectedVariant$.getValue();
                const recommendationParameters = getRecommendationParameters({ fit: selectedVariant.optionsMap.fit, size: selectedVariant.optionsMap.size, gender: window.productDepartment, sku: selectedVariant.sku });
                addToCartOverlay.setAttribute('recommendation-parameters', JSON.stringify(recommendationParameters));
                showModal([addToCartOverlay], { classes: 'add-to-cart-overlay' });
            }
            else {
                console.error("item added to cart successfully but no data returned");
            }
        }
        else {
            showInlineCart();
        }
    }
}
if (!window.customElements.get("product-secondary")) {
    customElements.define("product-secondary", ProductSecondary);
}
